const checkUserStripeSubscriptionExpired = (user) => {
  if (user) {
    return user.subscription_status !== 'active';
  }
  return false;
};

export { checkUserStripeSubscriptionExpired };
